import React from 'react';

import { AppGallery } from 'src/components/AppGallery';
import { ButtonApp } from 'src/components/Button';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import Box from '@mui/material/Box';
import {
  InfrastructureButton,
} from 'src/components/ViewSpinner/components/RenderSvg/components/InfrastructureType/components/InfrastructureButton';
import { IInfrastructureTypeGallery } from '../../types';
import { useStyles } from '../../styles';
import { useStyles as useStylesGallery } from './styles';
import { useGalleryState } from './hooks';

export const InfrastructureGallery: React.FC<IInfrastructureTypeGallery> = ({
  withBody,
  data,
}) => {
  const styles = useStyles({});
  const stylesGallery = useStylesGallery();
  const { gallery } = useGalleryState(data);

  return (
    <div className={styles.wrapperInfrastructureType}>
      {Boolean(gallery.length) && (
        <div className={`${styles.wrapperImage} ${withBody ? '' : styles.withoutBody}`}>
          <AppGallery
            lazyLoad
            showFullscreenButton
            additionalClass={stylesGallery.infrastructureSlideWrapper}
            items={gallery}
            showPlayButton={false}
            showThumbnails={false}
            renderFullscreenButton={(onClick, isFullscreen) => {
              return (
                <ButtonApp
                  style={{ position: 'absolute' }}
                  className={`image-gallery-fullscreen-button ${stylesGallery.zoomButton}`}
                  onClick={onClick}
                >
                  {
                    isFullscreen
                      ? <FullscreenExitIcon className={stylesGallery.zoomStyle} />
                      : <FullscreenIcon className={stylesGallery.zoomStyle} />
                  }
                </ButtonApp>
              );
            }}
          />
        </div>
      )}
      <Box width="100%">
        {data['infrastructure.body_text'] && (
          <p className={styles.textBody}>{data['infrastructure.body_text']}</p>
        )}
        <InfrastructureButton data={data} />
      </Box>
    </div>
  );
};
